import Vue from "vue";

import CoolLightBox from "@/components/vendor/VueCoolLightbox/CoolLightBox";

// import CoolLightBox from 'vue-cool-lightbox';
// import 'vue-cool-lightbox/dist/vue-cool-lightbox.min.css';
// Vue.use(CoolLightBox);
Vue.component("cool-light-box", CoolLightBox);